import React from 'react'
import EditPaymentSection from '../../../component/master-settings/payment-gateway/EditPaymentSection'

function EditPayment() {
  return (
    <div className='page-body'>
        <EditPaymentSection/>
    </div>
  )
}

export default EditPayment
